export const isNotNullUndefinedBlank = (data: any) => {
    return (data !== null && data !== undefined && data.trim() !== "");
};

export const isNotNullUndefined = (data: any) => {
    return (data !== null && data !== undefined);
};

export const isValidJSON = (jsonString: string): boolean => {
    try {
        JSON.parse(jsonString);
        return true;
    } catch (error) {
        console.warn(error);
        return false;
    }
};

export const isValidEmail = (value: any) => {
    // eslint-disable-next-line no-useless-escape
    const regex = /^(?!.*[._]{2})([a-zA-Z0-9_]+[._]?){1,5}[a-zA-Z0-9_]+@[a-zA-Z][a-zA-Z0-9_-]*(?<!-)\.[a-zA-Z]{2,}$/;
    return regex.test(value);
};

export const toTitleCase = (str: any) => {
    return isNotNullUndefined(str) ? str.toString()         // Convert passed data to string if it's not null/undefined 
        .toLowerCase()                   // Convert the entire string to lowercase first
        .split(/\s+/)                    // Split by one or more spaces (removes extra spaces)
        .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize first letter of each word
        .join(' ') : "";
};

export const getAuth0ProfileImageUrl = (url: any) => {
    return (isNotNullUndefinedBlank(url)) ? decodeURIComponent(new URL(url).searchParams.get('d') ?? (url || "")) : "";
};

export const handleError = (error: any) => {
    console.error("Error occurred:", error);
    
    let errorMessage = "An unexpected error occurred";
    
    if (isNotNullUndefined(error)) {
        if (typeof error === 'string') {
            errorMessage = error;
        } else if (error.message) {
            errorMessage = error.message;
        } else if (error.statusMessage) {
            errorMessage = error.statusMessage;
        } else if (error.error && error.error.message) {
            errorMessage = error.error.message;
        } else if (Object.keys(error).length > 0) {
            errorMessage = JSON.stringify(error);
        }
    }
    
    alert(errorMessage);
};